module.exports = __webpack_public_path__ + "static/media/nana-neutral.e432c647.png";